import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Payment from "./pages/payment/Payment";
import Dashboard from "./pages/customer/NewDashboard";
import Login from "./pages/auth/Login";
import Protected from "./components/Protected";
import Register from "./pages/customer/Register";
import RegisterTest from "./pages/customer/RegisterText";
import ForgetPassword from "./pages/auth/ForgetPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import SingleMemberLLC from "./pages/legalTools/SingleMemberLLC";
import SingleMemberLLCForm from "./pages/legalTools/SingleMemberLLCForm";
import NewSingleMemberLLCForm from "./pages/legalTools/NewSingleMemberLLCForm";
import MultiMemberLLC from "./pages/legalTools/MultiMemberLLC";
import NDABuilder from "./pages/legalTools/NDABuilder";
import CustomerAgreements from "./pages/agreements/CustomerAgreements";
import PaymentHistory from "./pages/payment/PaymentHistory1";
import Profile from "./pages/customer/Profile";
import { ErrorBoundary } from "react-error-boundary";
import Error from "./Error";
import ResetPasswordConfirmation from "./pages/auth/ResetPasswordConfirmation";
import MultiMemberLLCForm from "./pages/legalTools/MultiMemberLLCForm";
import MultiMemberLLCRegister from "./pages/customer/multiMemberLLCOnboarding/MultiMemberLLCRegister";
import MultiMemberLLCPayment from "./pages/customer/multiMemberLLCOnboarding/MultiMemberLLCPayment";
import Testing from "./Testing/Testing";
import Testing2 from "./Testing/Testing2";
import GenericForm from "./pages/GenericForm/GenericForm";
/* import CustomerAgreement from "./pages/agreements/CustomerAgreement"; */
/* import Dashboard1 from "./pages/customer/Dashboard"; */
//import './App.css'
/* import Testing from './components/Testing' */

function App() {
  return (
    <ErrorBoundary FallbackComponent={Error}>
      <>
        <Router>
          <Routes>
{/*           <Route exact path="/MakeForm" element={<Testing />} />
          <Route exact path="/DisplayForm" element={<Testing2 />} /> */}
            <Route exact path="/" element={<Login />} />
            <Route exact path="/login" element={<Login />} />
            {/* <Route exact path="/register/:userId" element={<Register />} /> */}
            <Route exact path="/register" element={<RegisterTest />} />
            <Route
              exact
              path="/MultiMemberOnboarding/:userData?"
              element={<MultiMemberLLCRegister />}
            />
            <Route
              exact
              path="/MultiMemberPayment/:userData"
              element={<MultiMemberLLCPayment />}
            />
            <Route exact path="/forgetpassword" element={<ForgetPassword />} />
            <Route
              exact
              path="/resetpasswordconfirmation"
              element={<ResetPasswordConfirmation />}
            />
            <Route
              exact
              path="/resetpassword/:customerId"
              element={<ResetPassword />}
            />
            <Route
              exact
              path="/dashboard"
              element={
                <Protected Component={Dashboard} navigation={"dashboard"} />
              }
            />
            <Route
              exact
              path="/legaltools/singlememberllc"
              element={
                <Protected
                  Component={SingleMemberLLC}
                  navigation={"singlememberllc"}
                />
              }
            />
            <Route
              exact
              /* path="/legaltools/singlememberllcform/:customerServiceId" */
              path="/legaltools/singlememberllcform/:customerServiceId"
              element={
                <Protected
                  Component={NewSingleMemberLLCForm}
                  navigation={"singlememberllc"}
                />
              }
            />
            <Route
              exact
              path="/legaltools/multimemberllc"
              element={
                <Protected
                  Component={MultiMemberLLC}
                  navigation={"multimemberllc"}
                />
              }
            />
            <Route
              exact
              path="/legaltools/multimembermemberllcform/:customerServiceId"
              element={
                <Protected
                  Component={GenericForm}
                 /*  Component={MultiMemberLLCForm} */
                  navigation={"multimemberllc"}
                />
              }
            />
            <Route
              exact
              path="/legaltools/ndabuilder"
              element={
                <Protected Component={NDABuilder} navigation={"ndabuilder"} />
              }
            />
            <Route
              exact
              path="/paymenthistory"
              element={
                <Protected
                  Component={PaymentHistory}
                  navigation={"paymenthistory"}
                />
              }
            />
            <Route
              exact
              path="/agreement"
              element={
                <Protected
                  Component={CustomerAgreements}
                  navigation={"agreement"}
                />
              }
            />
            <Route
              exact
              path="/profile"
              element={<Protected Component={Profile} navigation={"profile"} />}
            />
            <Route exact path="/payment/:userData" element={<Payment />} />
            <Route path="*" element={<Login />} />
          </Routes>
        </Router>
      </>
    </ErrorBoundary>
  );
}

export default App;
